import { Component, computed, inject } from '@angular/core';
import { GridCellBaseComponent } from '../grid-cell-base/grid-cell-base.component';
import { TranslatePipe } from '../../../../pipes/translate/translate.pipe';
import { ColorPickerComponent } from '@progress/kendo-angular-inputs';
import { CellActionType } from 'src/app/features/bizzmine/widgets/collection-list-widget/classes/cell-action-type';
import { ColorService } from 'src/app/core/services/colors/color.service';
import { CHECKLIST_BUTTON_DEFAULT_COLORS } from 'src/app/features/bizzmine/form/constants/checklist-button-default-colors';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';

@Component({
  selector: 'bizz-grid-cell-colorenum',
  standalone: true,
  imports: [
    TranslatePipe,
    ColorPickerComponent
  ],
  templateUrl: './grid-cell-colorenum.component.html',
  styleUrl: './grid-cell-colorenum.component.scss'
})
export class GridCellColorEnumComponent extends GridCellBaseComponent<string> {

  public propertyValue: string;
  public propertyText: string;
  public isCustom: boolean = false;
  private colorService = inject(ColorService);
  private themeService = inject(ThemeService);
  //If the column doesn't have have display styles we can reduce the padding (for id columns for example)
  public columnHasDisplayStyle = false;
  public isDarkTheme = computed(() => this.themeService.currentTheme$.value?.IsDarkTheme);

  protected override onDataChanged(): void {
    this.propertyText = '';
    this.propertyValue = this.data[this.column.field] ?? '';
    this.isCustom = false;
    if (this.propertyValue != undefined) {
      const colorPreset = CHECKLIST_BUTTON_DEFAULT_COLORS.find(col => col.Value?.BackgroundColor == this.propertyValue);
      if (colorPreset) {
        this.propertyText = colorPreset.Text;
        this.isCustom = this.propertyText == 'Custom';
        this.textColor = colorPreset.Value?.ForegroundColor ?? '#000000';
      } else {
        this.isCustom = true;
        this.propertyText = 'Custom';
        this.applyTextColor(this.propertyValue);
      }
    }
    ChangeDetectionService.detectChanges(this.changeDetectorRef);
  }

  public textColor: string = 'black';


  public applyTextColor(hex: string): void {
    this.textColor = this.colorService.generate800ContrastColor(hex);
  }

  public onValueChange($event: string): void {
    this.onCellAction.emit({
      data: {
        data: {
          data: this.data,
          column: this.column,
          value: $event
        }
      },
      action: CellActionType.CUSTOM_COLOR_CHANGE,
      mouseEvent: undefined
    });
  }
}